module.exports = __webpack_public_path__ + "assets/img/statis-waiting.41a6dc8b.svg";